import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <section className='fixed inset-0 z-[9999999999999999999999] bg-white'>


            <figure className='w-full h-[90dvh]'>
                <img className='w-full h-full object-contain' src="/404.png" alt="" />
            </figure>


            <Link to={'/'} className='text-center capitalize block text-white bg-myOrange w-fit mx-auto font-bold rounded-xl px-8 py-2'>
                go back
            </Link>

        </section>
    )
}

export default NotFound